<h2 mat-dialog-title *ngIf="program">Dispatch for {{ program.name }}</h2>
<h2 mat-dialog-title *ngIf="!program">New Dispatch</h2>

<mat-dialog-content *ngIf="dispatchForm" [formGroup]="dispatchForm" class="flex flex-wrap" style="gap: 20px; margin-top: 2rem">
  @if (dialogData.programs) {
    <mat-form-field appearance="outline">
      <mat-label>Select program *</mat-label>
      <input
        matInput
        [formControl]="searchControl"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        autoActiveFirstOption
        (optionSelected)="filterProgram($event)"
      >
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
          {{ option }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="dispatchForm.get('targetId')?.invalid">
        <div *ngIf="dispatchForm.get('targetId')?.errors?.required">
          Program must be selected
        </div>
      </mat-error>
    </mat-form-field>
  }

  <div formGroupName="dateTimeForm">
    <mat-form-field appearance="outline" style="margin-right: 20px">
      <mat-label>Start Date</mat-label>
      <input matInput formControlName="date" [matDatepicker]="picker" />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Start time</mat-label>
      <input matInput formControlName="startTime" [matTimepicker]="pickerTime">
      <mat-timepicker-toggle matIconSuffix [for]="pickerTime"/>
      <mat-timepicker #pickerTime/>
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Duration</mat-label>
    <input matInput type="number" formControlName="duration" />
    <mat-error *ngIf="dispatchForm.get('durationType')?.invalid">
      <div *ngIf="dispatchForm.get('durationType')?.errors?.required">
        Duration is required
      </div>
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Duration Type</mat-label>
    <mat-select formControlName="durationType">
      <mat-option [value]="'H'">Hour(s)</mat-option>
      <mat-option [value]="'M'">Minute(s)</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Dispatch KW</mat-label>
    <input matInput type="number" formControlName="setpoint" />
    <mat-error *ngIf="dispatchForm.get('setpoint')?.invalid">
      <div *ngIf="dispatchForm.get('setpoint')?.errors?.required">
        Dispatch is required
      </div>
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Incentive</mat-label>
    <input matInput type="number" formControlName="incentive" />
    <mat-error *ngIf="dispatchForm.get('incentive')?.invalid">
      <div *ngIf="dispatchForm.get('incentive')?.errors?.required">
        Incentive is required
      </div>
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Penalty</mat-label>
    <input matInput type="number" formControlName="penalty" />
    <mat-error *ngIf="dispatchForm.get('penalty')?.invalid">
      <div *ngIf="dispatchForm.get('penalty')?.errors?.required">
        Penalty is required
      </div>
    </mat-error>
  </mat-form-field>
  <div class="flex flex-col">
    <span style="margin-bottom: 0.5rem">Positive: Charging</span>
    <span>Negative: Discharging</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions *ngIf="dispatchForm">
  <div class="flex justify-end" style="width: 100%">
    <button mat-flat-button color="warn" (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" (click)="save()" [disabled]="!dispatchForm.valid">Save</button>
  </div>
</mat-dialog-actions>
